import { render } from "./Timer.vue?vue&type=template&id=16214ff2&bindings={\"time_left\":\"setup\",\"circleDasharray\":\"setup\",\"smallTimer\":\"setup\",\"subtasksDone\":\"setup\"}"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import "./Timer.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script